@import (reference) '../../../constants/spacing.module.less';

.layout-selector {
  display: flex;
  gap: @space-8;
  align-items: center;
}

.layout-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: @space-8;
  border: 1px solid var(--grey-300);
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  height: 32px;
  width: 40px;

  &:hover {
    background: var(--grey-100);
    border-color: var(--grey-400);
  }

  &.active {
    background: var(--blue-100);
    border-color: var(--blue-500);
  }

  &:focus-visible {
    outline: 2px solid var(--blue-500);
    outline-offset: 2px;
  }
}

.icon-grid {
  display: flex;
  gap: 2px;
  height: 16px;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.column-bar {
  flex: 1;
  height: 100%;
  background: var(--grey-600);
  border-radius: 1px;
  min-width: 3px;

  .active & {
    background: var(--blue-600);
  }
}
